import * as React from "react";

function SvgCadent(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 170 64"
      width="1em"
      height="1em"
      fill="none"
      {...{ ...props, ref }}
    >
      <g clipPath="url(#cadent_clip)">
        <path
          d="M157.188 0L159.71 10.9267L169.266 10.3522L159.845 16.0955L157.188 27.6046L154.601 16.3901L139.936 17.2536L154.601 11.2146L157.188 0Z"
          fill="#1100A7"
        />
        <path
          d="M27.776 31.0108C23.1672 28.9735 21.2934 28.6924 18.8866 28.6924C13.067 28.6924 9.15824 33.2239 9.15824 38.7421C9.15824 43.9098 12.6426 48.214 18.5618 48.214C21.3214 48.214 24.8808 47.3471 26.8374 46.1431L28.6462 53.9831C24.5246 55.438 21.7224 56.0002 17.9592 56.0002C6.92384 56.0002 0 48.8255 0 38.7925C0 28.7596 7.1232 20.9834 18.4621 20.9834C23.4987 20.9834 26.4779 22.0967 29.4493 23.7621L27.776 31.0108Z"
          fill="#000F59"
        />
        <path
          d="M33.0046 31.7869C34.9948 31.1239 38.8331 30.2234 43.0028 30.2234C52.2428 30.2234 53.9015 34.5354 53.9015 39.273V49.082C53.9015 51.7834 54.186 53.6303 54.6127 55.5253H47.0315C46.747 54.6248 46.5577 53.6773 46.4625 52.6346H46.3673C45.0412 54.5308 42.4831 55.9039 38.786 55.9039C33.7169 55.9039 30.8262 53.3928 30.8262 48.8445C30.8262 43.632 34.6644 40.0312 45.7995 39.7938V39.4623C45.7995 37.2357 44.4723 36.2882 41.4393 36.2882C38.0278 36.2882 35.043 37.2827 33.7639 37.9458L33.0057 31.7858L33.0046 31.7869ZM45.7983 45.8127V44.0588C40.6811 44.2962 38.9742 45.9067 38.9742 47.897C38.9742 49.4605 40.0639 50.361 41.5323 50.361C43.191 50.361 45.7972 49.176 45.7972 45.8127H45.7983Z"
          fill="#000F59"
        />
        <path
          d="M80.9459 20.9834V51.0722L81.1833 55.5264H73.5079L73.3175 52.4464H73.2235C71.8974 54.5789 69.4804 55.952 66.7319 55.952C63.083 55.952 56.4492 53.8196 56.4492 43.0642C56.4492 32.3088 63.1771 30.4127 66.826 30.4127C69.4793 30.4127 71.4225 31.5976 72.7015 33.4927H72.7967V21.4628L80.9459 20.9834ZM64.8358 43.0642C64.8358 48.2767 67.1105 49.4605 68.9115 49.4605C70.8065 49.4605 72.7967 47.7066 72.7967 44.5325V41.784C72.7967 38.4196 70.8535 36.9031 68.9585 36.9031C67.0635 36.9031 64.8358 37.8506 64.8358 43.0631V43.0642Z"
          fill="#000F59"
        />
        <path
          d="M106.365 54.4824C103.664 55.5498 100.143 56 97.0159 56C91.8986 56 83.6543 54.5788 83.6543 43.8211C83.6543 34.6763 89.5769 30.2703 96.0202 30.2703C101.043 30.2703 107.014 33.0187 107.014 42.5891C107.014 43.4426 106.966 44.2949 106.872 45.2424H91.2356C92.0409 49.2699 95.0727 50.1234 98.1057 50.1234C99.9066 50.1234 102.702 49.7919 105.118 49.0818L106.365 54.4824ZM91.1874 40.6H99.4799C99.7162 37.3307 97.8212 36.0035 95.7839 36.0035C93.5562 36.0035 91.7553 37.4719 91.1874 40.6Z"
          fill="#000F59"
        />
        <path
          d="M125.036 40.3627C125.036 38.7051 124.373 36.9042 122.003 36.9042C119.777 36.9042 117.929 38.6099 117.929 41.4043V55.5253H109.825V36.0037L109.588 30.743H117.311L117.454 34.3438H117.549C119.255 32.1173 121.339 30.2693 125.415 30.2693C130.39 30.2693 133.232 32.8744 133.232 38.8451V55.5242H125.035V40.3616L125.036 40.3627Z"
          fill="#000F59"
        />
        <path
          d="M135.706 30.7438H139.923V24.4505L148.12 23.9678V30.7438H154.598V36.7145H148.12V46.5223C148.12 48.2763 148.642 49.4601 150.774 49.4601C151.721 49.4601 152.527 49.366 153.38 49.1756L154.72 54.9873C152.796 55.8295 150.441 55.9998 148.782 55.9998C142.101 55.9998 139.922 52.5871 139.922 48.0388V36.7145H135.705V30.7438H135.706Z"
          fill="#000F59"
        />
      </g>
      <defs>
        <clipPath id="cadent_clip">
          <rect width="169.266" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgCadent);
